import { render, staticRenderFns } from "./RoundRobinPlay.vue?vue&type=template&id=789172a0&"
import script from "./RoundRobinPlay.vue?vue&type=script&lang=js&"
export * from "./RoundRobinPlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports